// Source/Product-Painter/Component.ts
class ProductPainter extends HTMLElement {
  controller = new AbortController;
  connectedCallback() {
    const { signal } = this.controller;
    this.opener.addEventListener("click", this.open.bind(this), { signal });
    this.loadGallery();
  }
  disconnectedCallback() {
    this.controller.abort();
  }
  loadGallery() {
    let configId = null;
    const config = lastConfig();
    if (config) {
      const { productId, variantId } = config;
      if (this.dataset.product === String(productId) && this.dataset.variant === String(variantId))
        configId = config.configId;
    }
    const event = new CustomEvent("Painter:Render", {
      detail: { configId }
    });
    document.dispatchEvent(event);
  }
  open() {
    const { product } = this;
    const event = new CustomEvent("Painter:Open", {
      detail: { product, configId: null }
    });
    document.dispatchEvent(event);
  }
  get product() {
    const script = this.querySelector(`script[ type = 'application/json' ]`);
    const json = script.textContent;
    return JSON.parse(json);
  }
  get opener() {
    return this.querySelector(`& > button`);
  }
}
function lastConfig() {
  const json = localStorage.getItem("configurator-last-active-config");
  if (!json)
    return;
  return JSON.parse(json);
}

// Source/Product-Painter/mod.ts
customElements.define("product-painter", ProductPainter);
